(() => {
    function addToCart() {
        Alpine.data('addToCart', () => ({
            adding: false,
            isInStock: true,
            isPurchasable: true,
            quantity: 1,
            minQuantity: 1,
            maxQuantity: 999999,
            productId: null,

            init() {
                this.productId = parseInt(this.$el.dataset.productId);

                let minQty = parseInt(this.$el.dataset.minQuantity);
                let maxQty = parseInt(this.$el.dataset.maxQuantity);
                let stockStatus = this.$el.dataset.stockStatus;

                this.minQuantity = minQty > 0 ? minQty : 1;
                this.maxQuantity = maxQty > 0 ? maxQty : 999999;

                if (this.maxQuantity < this.minQuantity) {
                    this.maxQuantity = this.minQuantity;
                }
                this.quantity = this.minQuantity;

                if (stockStatus === 'instock') {
                    this.isInStock = true;
                } else {
                    this.isInStock = false;
                }
            },

            decreaseQuantity() {
                if (this.quantity > this.minQuantity) {
                    this.quantity--;
                }
            },

            increaseQuantity() {
                if (this.quantity < this.maxQuantity) {
                    this.quantity++;
                }
            },

            updateQuantity(value) {
                const num = parseInt(value);
                if (!isNaN(num)) {
                    if (num < this.minQuantity) {
                        this.quantity = this.minQuantity;
                    } else if (num > this.maxQuantity) {
                        this.quantity = this.maxQuantity;
                    } else {
                        this.quantity = num;
                    }
                }
            },

            async addToCart() {
                if (this.adding) return;


                this.adding = true;

                try {
                    const response = await fetch(
                        wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
                        {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'X-Requested-With': 'XMLHttpRequest',
                            },
                            body: new URLSearchParams({
                                product_id: this.productId,
                                quantity: this.quantity,
                                action: 'woocommerce_add_to_cart',
                            }),
                        }
                    );

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();


                    if (data.error) {

                        return;
                    }

                    if (data.fragments) {
                        // Fragments update
                        Object.entries(data.fragments).forEach(([selector, html]) => {
                            const elements = document.querySelectorAll(selector);
                            elements.forEach((el) => {
                                el.outerHTML = html;
                            });
                        });

                        // Event dispatch
                        if (window.jQuery) {
                            window.jQuery(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash]);
                        } else {
                            document.body.dispatchEvent(
                                new CustomEvent('added_to_cart', {
                                    detail: [data.fragments, data.cart_hash, data],
                                })
                            );
                        }


                    }

                    // FunnelKit Cart refresh
                    if (window.FKCart && typeof window.FKCart.refresh === 'function') {
                        window.FKCart.refresh();
                    }

                    // Quantity reset
                    this.quantity = this.minQuantity;
                } catch (error) {

                } finally {
                    this.adding = false;
                }
            },
        }));
    }

    if (typeof Alpine !== 'undefined' && Alpine.version) {
        addToCart();
    } else {
        document.addEventListener('alpine:init', () => {
            addToCart();
        });
    }
})();
